import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=6c465f1a"
import script from "./Wrapper.vue?vue&type=script&lang=js"
export * from "./Wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c465f1a')) {
      api.createRecord('6c465f1a', component.options)
    } else {
      api.reload('6c465f1a', component.options)
    }
    module.hot.accept("./Wrapper.vue?vue&type=template&id=6c465f1a", function () {
      api.rerender('6c465f1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/Wrapper.vue"
export default component.exports